import EventEmitter from 'eventemitter3';

// Singleton EventEmitter instance for export refresh events
class ExportRefreshEventEmitter extends EventEmitter {
  private static instance: ExportRefreshEventEmitter;

  private constructor() {
    super();
  }

  public static getInstance(): ExportRefreshEventEmitter {
    if (!ExportRefreshEventEmitter.instance) {
      ExportRefreshEventEmitter.instance = new ExportRefreshEventEmitter();
    }
    return ExportRefreshEventEmitter.instance;
  }

  // Event constants
  public static readonly REFRESH_EXPORT_HISTORY = 'refresh_export_history';
  public static readonly EXPORT_COMPLETED = 'export_completed';

  // Type-safe methods
  public refreshExportHistory(): void {
    this.emit(ExportRefreshEventEmitter.REFRESH_EXPORT_HISTORY);
  }

  public onRefreshExportHistory(callback: () => void): void {
    this.on(ExportRefreshEventEmitter.REFRESH_EXPORT_HISTORY, callback);
  }

  public offRefreshExportHistory(callback: () => void): void {
    this.off(ExportRefreshEventEmitter.REFRESH_EXPORT_HISTORY, callback);
  }

  public notifyExportCompleted(data: any): void {
    this.emit(ExportRefreshEventEmitter.EXPORT_COMPLETED, data);
  }

  public onExportCompleted(callback: (data: any) => void): void {
    this.on(ExportRefreshEventEmitter.EXPORT_COMPLETED, callback);
  }

  public offExportCompleted(callback: (data: any) => void): void {
    this.off(ExportRefreshEventEmitter.EXPORT_COMPLETED, callback);
  }
}

// Export singleton instance
export const exportRefreshEventEmitter = ExportRefreshEventEmitter.getInstance();
